import { DecimalPipe } from "@angular/common";
import { Component, ViewChild, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { ApiService, } from "src/app/api.service";
import { DvsUtilities } from "src/app/dvs-utilities";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { ItemHealth } from "src/app/item-health";
import { RuntimePipe, IfEmptyPipe, RemoveBaselinePipe } from "src/app/pipes";
import { PreventNavIfSelectedDirective } from "src/app/prevent-nav-if-selected.directive";
import { HealthStatusIndicatorComponent } from "src/app/shared/health-status-indicator/health-status-indicator.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-asset",
	templateUrl: "./asset.component.html",
	styleUrls: ["./asset.component.scss"],
	imports: [RouterLink, RouterLinkActive, PreventNavIfSelectedDirective, HealthStatusIndicatorComponent, RouterOutlet, DecimalPipe, RuntimePipe, IfEmptyPipe, RemoveBaselinePipe]
})
export class AssetComponent {
	private route = inject(ActivatedRoute);
	private router = inject(Router);
	private title = inject(Title);
	private api = inject(ApiService);
	private fleettracker = inject(FleetTrackerService);

	@ViewChild("assetDetail") assetDetail: any;

	public fleet?: APIResults.Fleet;
	public asset?: APIResults.FleetAsset;
	public components?: APIResults.AssetComponentList;
	public worstrulcomponent?: AssemblyConfig.Component;
	public worsthicomponent?: AssemblyConfig.Component;
	public brand = BrandVars;
	public maxFunc = Math.max;
	public hiHelp = "Below 0.75: Normal\n0.75 - 1.0: Warning\nAbove 1.0: Attention needed";
	public lastOperation: APIResults.Operation;
	public assetIcon?: string;
	public itemHealth: ItemHealth;

	constructor() {
		let selected_asset_id: number;
		// A change in either the route parameter or the selected fleet must trigger a selection
		this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
			if (Number(params["assetid"]) !== selected_asset_id) {
				selected_asset_id = Number(params["assetid"]);
				this.fleettracker.SelectAsset(selected_asset_id);
			}
		});
		this.fleettracker.currentFleet.pipe(takeUntilDestroyed()).subscribe(item => {
			this.fleettracker.SelectAsset(selected_asset_id);
			this.fleet = item;
		});
		this.fleettracker.currentAsset.pipe(takeUntilDestroyed()).subscribe(async item => {
			this.asset = item;
			if (this.asset) {
				// Log access, don't wait
				this.api.LogAssetAccess(this.asset.asset_id).catch(() => console.error("Couldn't log access"));
				this.title.setTitle(BrandVars.appName + " - " + this.asset.asset_name);
				this.worstrulcomponent = undefined;
				this.worsthicomponent = undefined;
				const result = await this.api.GetComponents(this.asset.asset_id);
				if (result.alt_asset_icon) {
					this.assetIcon = result.alt_asset_icon;
				} else {
					this.assetIcon = "asset";
				}
				this.itemHealth = ItemHealth.FromAsset(this.asset as APIResults.FleetAsset);

				// Find worst RUL
				// TODO: we now calculate these on the server, so we should just get them from the asset
				let worstrul: any = { state: { rul: Infinity } };
				let worsthi: any = { state: { filtered_hi: 0 } };
				const flattened = DvsUtilities.FlattenComponents(result);
				for (const comp of flattened) {
					if (comp.state && comp.state.rul && comp.state.rul > 0.5 && comp.state.rul < worstrul.state.rul) {
						worstrul = comp;
					}
					if (comp.state && comp.state.filtered_hi && comp.state.filtered_hi > worsthi.state.filtered_hi) {
						worsthi = comp;
					}
				}
				if (worstrul && worstrul.name) {
					this.worstrulcomponent = worstrul;
				}
				if (worsthi && worsthi.name) {
					this.worsthicomponent = worsthi;
				}
				this.components = result;
				if (!this.asset.is_fixed) {
					const operations = await this.api.GetOperations(this.asset.asset_id, 1);
					if (operations && operations.length === 1) {
						this.lastOperation = operations[0];
					}
				}
				if (this.asset.is_fixed || (this.api.user?.hide_rtb)) {
					this.router.navigate(["md"], { relativeTo: this.route, replaceUrl: true });
				}
				// TODO: Error handling
			} else {
				this.components = undefined;
			}
		});
	}

	private activeRouteComponent: any;
	public updateRouterOutlet(routecomponent?: any) {
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.activeRouteComponent) {
			this.activeRouteComponent.asset = this.asset;
			this.activeRouteComponent.fleet = this.fleet;
			this.activeRouteComponent.components = this.components;
		}
		this.scrollToSection();
	}

	private scrollToSection() {
		const element = this.assetDetail?.nativeElement;
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}
}
